import React from "react";
import Logo from '../img/twicces.png';
import { FaFacebook, FaTwitter, FaInstagram } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  return (
    <footer data-aos="zoom-in-up">
        <section id="footer_inner_wrapper">
          <article className="twiceasgood-footer">
            <div className="twiceasgoodImg-footer_holder" data-aos="fade-left">
              <img src={Logo} alt="Twice As Good Logo" />
            </div>
            <p data-aos="fade-left">
              Our motto is to fulfill customer<br/>
              demand by making them satisfied<br/>
              with growing their business
            </p>
          </article>
          <article className="company-footer" data-aos="fade-left">
            <h4>Company</h4>
            <ul>
              <li>
                <NavLink  to="/" className={({ isActive }) => ( isActive ? "" : "link" )}>home</NavLink>
              </li>
              <li>
                <NavLink  to="/about" className={({ isActive }) => ( isActive ? "" : "link" )}>About us</NavLink>
              </li>
              <li>
                <NavLink  to="/contact" className={({ isActive }) => ( isActive ? "" : "link" )}>Conatct us</NavLink>
              </li>
            </ul>
          </article>
          <article className="social-media-handle" data-aos="fade-left">
             <h4>CALL US</h4>
             <p>07065112269</p>
             <h4 className="follow-us">FOLLOW US</h4>
             <div className="social-icon-holder">
                <span className="icon1"><FaTwitter /></span>
                <span className="icon2"><FaInstagram /></span>
                <span className="icon3"><FaFacebook /></span>
             </div>
          </article>
        </section>
        <section id="copy-write">&#169; 2023 TwiceAsGood. Digital Marketing Agency, Port Harcourt, Nigeria. All Rights Reserved</section>
    </footer>
  );
};
export default Footer;